import { PageBody } from "@Light/components/page/PageBody";
import { useScaffold } from "@Light/scaffold";
import { PlanContext, RateContext } from "@Light/utils/plan";
import { planFeaturesForRateGroup } from "@Light/utils/planFeatures";
import { useRateGroup } from "@Light/utils/rateGroup";
import { useEnrollment } from "../flow/context";
import { useEnrollmentStepper } from "../flow/useEnrollmentStepper";
import { EnrollRoute } from "../routes";
import { EnrollmentConfirmationCards } from "./EnrollmentConfirmationCards";
import { Footer } from "./Footer";
import { usePatchedRate } from "./usePatchedRate";

export const VerifyAndEnroll = () => {
  const scaffold = useScaffold();
  const { data: rate, isError } = usePatchedRate();
  const group = useRateGroup(rate?.group_uuid);

  if (isError) {
    const Field = scaffold.system.field;
    const ErrorMessage = scaffold.system.errorMessage;
    return (
      <Field>
        <ErrorMessage>
          Failed querying rate data. Please try again later
        </ErrorMessage>
      </Field>
    );
  }

  if (!rate || !group) {
    return null;
  }

  const features = planFeaturesForRateGroup(rate);

  return (
    <PlanContext.Provider value={{ group, features }}>
      <RateContext.Provider value={rate}>
        <VerifyAndEnrollB1 />
      </RateContext.Provider>
    </PlanContext.Provider>
  );
};

export const VerifyAndEnrollB1 = () => {
  const { back } = useEnrollment();
  const stepper = useEnrollmentStepper(EnrollRoute.VerifyAndEnroll);

  return (
    <PageBody
      onBack={back}
      title="Review your details below and we'll handle the rest"
      stepper={stepper}
    >
      <div className="flex flex-col gap-3xl pb-3xl">
        <EnrollmentConfirmationCards />
        <div className="py-xl">
          <div className="w-full border-t border-secondary" />
        </div>
        <Footer />
      </div>
    </PageBody>
  );
};
